export default function checkUrl(str) {
  try {
    return Boolean(new URL(str));
  } catch (e) {
    return false;
  }
}
